import { DropDownButton } from 'devextreme-react';
import React, { useState } from 'react';
import { deleteApi, putApi } from '../../apiUtils';
import { useTranslation } from '../../contexts/translation';
import { API_URL } from '../../utils/apiUrl';
import { FileRenameInput } from './FileRenameInput';

interface Props {
  id: number;
  name: string;
  url: string;
  entityName: string;
  entityId: number;
  onDelete: () => void;
  onRename: () => void;
}

export const colors = {
  primary: '#346cb0',
};

export const iconStyles = {
  display: 'block',
  marginTop: '35px',
  marginBottom: '5px',
  fontSize: '55px',
  textAlign: 'center' as const,
};

export const HyperLink = ({ id, name, entityName, entityId, url, onDelete, onRename }: Props) => {
  const { translate } = useTranslation();
  const transFormName = 'File';
  const [isRenameInputVisible, setRenameInputVisible] = useState(false);

  const dropDownActions = [
    { id: 1, name: translate!('Rename', transFormName), icon: 'edit' },
    { id: 2, name: translate!('Delete', transFormName), icon: 'remove' },
  ];

  const handleDelete = async () => {
    if (!window.confirm(translate!('You sure?', transFormName))) return;

    await deleteApi({
      url: `${API_URL.HYPERLINK_DELETE}?id=${id}`,
      id: id,
      callAfterSuccess: () => {
        onDelete();
      },
    });
  };

  const handleRename = async (id: number, entityId: number | string, name: string) => {
    await putApi({
      url: `${API_URL.HYPERLINK_UPDATE}`,
      data: {
        id,
        entity: entityName,
        entityId: Number(entityId),
        name,
        uri: url,
      },
      callAfterSuccess: () => {
        setRenameInputVisible(false);
        onRename();
      },
    });
  };

  const onDropDownItemClick = (e) => {
    switch (e.itemData.id) {
      case 1:
        setRenameInputVisible(true);
        break;
      case 2:
        handleDelete();
        break;
    }
  };

  const handleLinkOpen = (url: string) => {
    let _url = url;
    if (_url.includes('http://') || _url.includes('https://')) {
      window.open(_url, '_target');
      return;
    }

    _url = `https://${url}`;
    window.open(_url, '_target');
  };

  return (
    <div key={id} className={`file-figure file`} style={{ textAlign: 'left' }}>
      <div
        style={{
          cursor: 'pointer',
          height: '125px',
          minHeight: '125px',
          minWidth: '100px',
          overflow: 'hidden',
        }}
        title={url}
        onClick={() => handleLinkOpen(url)}
      >
        <i
          className="dx-icon-folder dx-icon-custom-style"
          style={{ ...iconStyles, color: colors.primary }}
          aria-hidden="true"
        />
      </div>
      {!isRenameInputVisible ? (
        <div className="figure-caption">{name}</div>
      ) : (
        <FileRenameInput
          fileId={id}
          entityId={entityId}
          description={name}
          handleFileRename={handleRename}
          handleFileRenameCancel={setRenameInputVisible}
        />
      )}
      <div className={'buttons'}>
        <DropDownButton
          text={'More actions'}
          icon="preferences"
          displayExpr="name"
          keyExpr="id"
          items={dropDownActions}
          onItemClick={onDropDownItemClick}
        />
      </div>
    </div>
  );
};
